import React from 'react';
import Modal from 'react-modal';
import { useSetViewContext, useViewContext } from '../contexts/viewContext';
import styled from 'styled-components/macro';
import RoundButton from '../components/Botones/RoundButton';

const ModalHistoricos = () => {
  const {
    modalHistoricos: { open, url },
  } = useViewContext();
  const setViewContext = useSetViewContext();
  return (
    <Modal
      style={{
        overlay: {
          zIndex: 10000,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        },
        content: { width: '95vw', height: '95vh', inset: 'unset' },
      }}
      isOpen={open}
    >
      <ModalContent>
        <ModalHeader>
          <RoundButton
            onClick={() =>
              setViewContext(s => ({
                ...s,
                modalHistoricos: {
                  ...s.modalHistoricos,
                  open: false,
                  url: null,
                },
              }))
            }
          >
            <svg
              width="30"
              height="30"
              viewBox="0 0 39 39"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.59218 36.1717C0.0163606 33.5958 0.0163593 29.4196 2.59218 26.8438L26.7274 2.70858C29.3032 0.132757 33.4794 0.132762 36.0553 2.70859C38.6311 5.28441 38.6311 9.46065 36.0553 12.0365L11.9201 36.1717C9.34424 38.7475 5.16801 38.7475 2.59218 36.1717ZM2.1503 11.1033C-0.289854 8.66312 -0.289857 4.70685 2.15029 2.2667C4.59045 -0.173453 8.54671 -0.173453 10.9869 2.2667L36.5695 27.8493C39.0096 30.2894 39.0096 34.2457 36.5695 36.6859C34.1293 39.126 30.173 39.126 27.7329 36.6859L2.1503 11.1033Z"
                fill="white"
              />
            </svg>
          </RoundButton>
        </ModalHeader>
        <ModalBody>
          {url ? <ModalIframe src={url} title="historico" /> : null}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

const ModalContent = styled.div`
  display: grid;
  grid-template-rows: 60px 1fr;
  gap: 15px;
  width: 100%;
  height: 100%;
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
`;

const ModalBody = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ModalIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: 1px solid #c8c8c8;
  border-radius: 5px;
  background-color: #c8c8c8;
`;

export default ModalHistoricos;
